let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("a7qaW")).then(() => parcelRequire('e90wJ'));